<div class="chapter-item">
  <div class="chapter-header">
    <div class="left">
      @if(isGlobalEditMode)
      {
      <!-- order -->
      <input type="number" class="molv-order-input molv-order-input-small" [value]="chapter.order"
        (change)="onOrderChange($event)" [disabled]="filesProcessing">
      }
      @if(filesProcessing) {
      <div class="molv-spinner small"></div>
      }
      @else {
      <span class="arrow" (click)="toggle()" [class.open]="isOpen"></span>
      }
      
      <div class="title-container">
        <molv-textbox [value]="isEditMode ? editTitle : chapter.title" (valueChange)="editTitle = $event"
          [isEditMode]="isEditMode"> </molv-textbox>
      
        @if(bookmarksCount > 0) {
        <span class="bookmark-count">
          {{ bookmarksCount }}
          {{ bookmarksCount === 1 ? ('bookmark' | transloco) : ('bookmarks' | transloco) }}
        </span>
        }
      </div>
      </div>

    <div class="right">
      <span class="count">
        {{ pagesCount }} {{ pagesCount !== 1 ? ('pages' | transloco) : ('page' | transloco) }}
      </span>

      @if(isEditMode) {
      <button class="molv-btn molv-btn-green" (click)="saveAndClose()" [disabled]="filesProcessing"
        [class.disabled]="filesProcessing">
        {{ 'save' | transloco }}
      </button>

      <button class="molv-btn molv-btn-red" (click)="delete()" [disabled]="filesProcessing"
        [class.disabled]="filesProcessing">
        {{ 'delete' | transloco }}
      </button>

      <button class="molv-btn molv-btn-pink" (click)="cancel()" [disabled]="filesProcessing"
        [class.disabled]="filesProcessing">
        {{ 'cancel' | transloco }}
      </button>
      }
      @else{
      <button class="molv-btn molv-btn-orange" (click)="upload($event)">
        {{ 'edit' | transloco }}
      </button>

      <button class="molv-btn molv-btn-pink" (click)="openChapter()">
        {{ 'read' | transloco }}
      </button>
      }
    </div>
  </div>

  <div class="pages" *ngIf="isOpen">
    @if(isEditMode) {
    <!-- uploader -->
    <molv-drop-uploader [visible]="isOpen && isEditMode" [saveAll$]="saveAll$" [clearAll$]="clearAll$"
      [chapterId]="chapter.id" [tabId]="chapter.tabId" (onDropFinished)="onUploadFinished()"
      (filesProcessing)="filesProcessing = $event">
    </molv-drop-uploader>
    }
    @else {
    <!-- pages -->
    <div class="page-item" *ngFor="let page of pages; let i = index" (click)="openPage(page.id!)">
      {{ i + 1 }} {{ pagesCount !== 1 ? ('pages' | transloco) : ('page' | transloco) }}
      
      @if(hasBookmark(page.id!)) {
      <img src="assets/icons/molv-bookmark.svg" class="molv-bookmark-icon">
      }
    </div>
    }
  </div>
</div>